import React from 'react';

import {useTranslation} from 'react-i18next';

import {formatLocalDateTime, translateUserRole} from 'components/pages/RecallAudit/utils';

import {Field, FieldLabel, GeneralFieldsGrid, FieldValue, Section, SectionTitle} from './styled';

interface Props {
    children?: React.ReactNode;
    entry: {
        eventTimestamp: string;
        userId?: string;
        userRole?: string;
        userFullName?: string;
        ipAddress?: string;
        userAgent?: string;
    };
}
export const AuditGeneralInformation = ({entry, children}: Props) => {
    const {t} = useTranslation();
    const fields = [
        ['dateTime', formatLocalDateTime(entry.eventTimestamp)],
        ['userId', entry.userId],
        ['userRole', translateUserRole(t, entry.userRole)],
        ['fullName', entry.userFullName],
        ['ipAddress', entry.ipAddress],
        ['userAgent', entry.userAgent],
    ];
    return (
        <Section>
            <SectionTitle>{t('pages.recallAudit.detail.general')}</SectionTitle>
            <GeneralFieldsGrid>
                {fields.map(([key, value]) => (
                    <Field key={key} wide={key === 'userAgent'}>
                        <FieldLabel>{t(`pages.recallAudit.detail.${key}`)}</FieldLabel>
                        <FieldValue>{value || '—'}</FieldValue>
                    </Field>
                ))}
                {children}
            </GeneralFieldsGrid>
        </Section>
    );
};
